<script setup>
  const props = defineProps({
    fillColor: {
      type: String,
      default: '#ffffff'
    }
  })
</script>

<template>
  <svg class="jwx-wind-gauge__marker jwx-wind-gauge__marker--no-dir" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <circle class="jwx-wind-gauge__marker-fill" :fill="fillColor" cx="6" cy="6" r="5"/>
      <path class="jwx-wind-gauge__marker-border" d="M6 .55c3.00995 0 5.45 2.44005 5.45 5.45 0 3.00995-2.44005 5.45-5.45 5.45C2.99005 11.45.55 9.00995.55 6 .55 2.99005 2.99005.55 6 .55Zm0 .9C3.4871 1.45 1.45 3.4871 1.45 6c0 2.5129 2.0371 4.55 4.55 4.55 2.5129 0 4.55-2.0371 4.55-4.55 0-2.5129-2.0371-4.55-4.55-4.55Z"/>
    </g>
  </svg>
</template>